export const initialWithdrawFormData = {
  ids: '',
  reason: '',
};
